module.exports = __webpack_public_path__ + "static/media/BlueCross.7c46a12e.svg";